// Signal source + status metadata and styles (Phase 6).

export const SOURCE_LABEL = { alert: "Alert", manual: "Manual", chat: "Chat" };

export const STATUS = {
  pending: { label: "Pending", cls: "text-amber-400 border-amber-500/40 bg-amber-500/10" },
  approved: { label: "Approved", cls: "text-emerald-400 border-emerald-500/40 bg-emerald-500/10" },
  rejected: { label: "Rejected", cls: "text-red-400 border-red-500/40 bg-red-500/10" },
  silenced: { label: "Silenced", cls: "text-muted-foreground border-border/60 bg-muted/40" },
};

export const STATUS_FILTERS = [
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "silenced", label: "Silenced" },
  { value: "all", label: "All" },
];

export const REVIEW_ROLES = ["owner", "admin", "analyst"];

export function canReviewRole(role) {
  return REVIEW_ROLES.includes(role);
}

export function fmtNum(v) {
  if (v === null || v === undefined || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return n.toLocaleString(undefined, { maximumFractionDigits: 2 });
}
